import React, { useEffect } from 'react';
import { VaBreadcrumbs } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { useFeatureToggle } from '~/platform/utilities/feature-toggles/useFeatureToggle';
import SubmissionsWrapper from '../components/SubmissionsWrapper';
import { submitFormsBC } from '../utilities/poaRequests';
import SubmitFormsAndFilesContent from '../components/SubmitFormsAndFilesContent';
import { SUBMISSIONS_PATH } from '../utilities/constants';

const SubmitFormsAndFilesPage = title => {
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const isSubmissionsUpdateEnabled = useToggleValue(
    TOGGLE_NAMES.accreditedRepresentativePortalCdUpdateMain,
  );

  useEffect(() => {
    document.title = title.title;
  }, [title]);

  return (
    <section className="vads-u-width--full claimant-details-submission-history">
      <div className="claimant-details-submission-history__breadcrumbs">
        <VaBreadcrumbs
          breadcrumbList={submitFormsBC}
          homeVeteransAffairs={false}
          wrapping
        />
      </div>

      <SubmissionsWrapper>
        <h2
          data-testid="submission-history-page-heading"
          className="vads-u-margin-y--0"
        >
          Submit forms and files
        </h2>
        <p className="va-introtext vads-u-margin-y--0 vads-u-margin-bottom--2">
          Submit online forms, or upload forms or documents.
        </p>
        {isSubmissionsUpdateEnabled ? (
          <SubmitFormsAndFilesContent />
        ) : (
          <>
            <p>This page isn’t available yet.</p>
            <va-link-action
              href={SUBMISSIONS_PATH}
              text="Go to Submissions page"
              type="primary"
            />
          </>
        )}
      </SubmissionsWrapper>
    </section>
  );
};

export default SubmitFormsAndFilesPage;
